var parse = require('./parse')
var stringify = require('./stringify')

module.exports = parse
module.exports.parse = parse
module.exports.stringify = stringify



//////////////////
// WEBPACK FOOTER
// ./~/protocol-buffers-schema/index.js
// module id = 368
// module chunks = 0